import generateUUID from '@business/utils/uuid';
import Accommodation from './Accommodation';
import Addon from './Addon';

export type ReservationItemAccommodation = {
  type: 'accommodation';
  item: Accommodation;
  amount: number;
  adults: number;
  kids: number;
  unit?: string;
};

export type ReservationItemAddons = {
  amount: number;
  type: 'addon';
  item: Addon;
};

type ReservationItemModel =
  | ReservationItemAccommodation
  | ReservationItemAddons;

export default class ReservationItem {
  id!: string;
  model?: ReservationItemModel;

  constructor(data: ReservationItemModel) {
    this.id = generateUUID();
    this.model = data;
  }

  getName() {
    if (!this.model) return '';
    if (this.model.type === 'accommodation') {
      if (this.model.unit) {
        return `${this.model.item.name} - ${this.model.unit}`;
      }
    }
    return this.model?.type === 'accommodation'
      ? this.model?.item.name
      : this.model?.item.name.getText();
  }

  getPrice() {
    if (!this.model) return 0;
    return this.model.item.rate * this.model.amount;
  }

  getItemId() {
    return this.model?.item.id;
  }
}
